<button
  type="button"
  bitIconButton="bwi-grid"
  [bitMenuTriggerFor]="content?.menu"
  [buttonType]="buttonType"
  [label]="'switchProducts' | i18n"
  *ngIf="products$ | async"
></button>
<product-switcher-content #content></product-switcher-content>
